<app-details-divider></app-details-divider>
<div class="ms-3 hstack my-4 gap-3">
  <app-data-box [label]="'Luogo di Nascita'" [data]="user?.luogo_di_nascita"></app-data-box>
  <app-data-box [label]="'Provincia di Nascita'" [data]="user?.provincia_di_nascita"></app-data-box>
</div>
<div class="ms-3 hstack mb-4 gap-3">
  <app-data-box [label]="'Data di Nascita'" [data]="user?.data_di_nascita | date:'dd-MM-yyyy'"></app-data-box>
  <app-data-box [label]="'Nazionalità'" [data]="user?.nazionalita"></app-data-box>
</div>
